import { Pipe, PipeTransform } from '@angular/core';

import { AccountGroupMembership } from '@libs/src/models/account.model';

import { getMembership } from '../../account/account.helpers';

@Pipe({
  name: 'appGroupMembership',
})
export class GroupMembershipPipe implements PipeTransform {
  transform(
    value: AccountGroupMembership[],
    groupId: string,
  ): AccountGroupMembership {
    return getMembership(value, groupId);
  }
}
